var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 286.38 138.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        opacity: .07;\n      }\n\n      .cls-3 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-4 {\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-6 {\n        fill: #b0bec5;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.4,
    y1: 69.25,
    x2: 276.72,
    y2: 69.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#138bcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1652a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 114.74,
    y1: 99.28,
    x2: 154.52,
    y2: 99.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.46,
    dy: 2.46
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.46,
    dy: 2.46
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 0
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Splash_Screen",
    "data-name": "Splash Screen"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m252.08,37.15v41.28h-33.27c-5.89,0-8.62-1.85-8.62-8.01v-33.27h-16.74V0h-24.65v41.16c-3.51-2.48-8.23-4.01-14.58-4.01h-26.79c-.35-1.05-.52-2.33-.52-3.88V0h-24.64v37.15h-1.14v24.88s3.6,0,8.68,0c3.74,2.84,9.21,4.51,17.1,4.51h26.61c.58,1.39.84,3.15.84,5.38h-41.88c-7.75,0-13.08,1.86-16.74,4.61v-41.65c0-11.2.17-34.88-24.78-34.88H17.86v24.88s36.69,0,40.69,0c9.36,0,12.54,2.05,12.54,9.89H29.19c-24.95,0-24.79,19.29-24.79,25.3v14.79c0,8.54,2.05,26.49,24.95,26.49h58.32v10.65c0,8.55,2.05,26.49,24.95,26.49h66.38v-38.36c3.39-1,6.88-2.84,9.58-6.26,3.22,5.97,9.62,9.8,21.6,9.8h41.89v1.85c0,5.23-1.68,8.38-8.32,8.38h-45.75v24.58h54.07c6.24,0,24.64,0,24.64-24.64V37.15h-24.64Zm-180.84,39.55h-36.51c-4.66,0-5.38-3.08-5.38-5.72v-6.91c0-1.85,1.39-4.01,4.78-4.01h37.12v16.64Zm83.27,37.15h-36.5c-4.67,0-5.4-3.08-5.4-5.71v-6.92c0-1.26.64-2.66,2.12-3.42.7-.36,1.57-.58,2.66-.58h37.12v16.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m154.52,97.22v4.13h-39.77v-3.55c.7-.36,1.57-.58,2.66-.58h37.12Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m231.35,67.08h-8.28v-34.46h22.75c6.91,0,8.21,5.38,8.21,11.86v22.6h-8.33s-.08-18.75-.08-21.42c0-4.35-2.99-4.56-7.07-4.56h-7.15l-.05,25.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m22.63,32.62H4.57v8.46s12.48,0,13.84,0c3.18,0,4.27.7,4.27,3.37h-14.25C-.05,44.44,0,51.01,0,53.05v5.03C0,60.98.7,67.08,8.48,67.08h22.58v-22.6c0-3.81.06-11.86-8.43-11.86Zm.1,26.08h-12.41c-1.59,0-1.83-1.05-1.83-1.94v-2.35c0-.63.47-1.36,1.62-1.36h12.62v5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m210.72,32.62h-18.06v8.46s12.48,0,13.84,0c3.18,0,4.27.7,4.27,3.37h-14.25c-8.49,0-8.43,6.56-8.43,8.6v5.03c0,2.91.7,9.01,8.48,9.01h22.58v-22.6c0-3.81.06-11.86-8.43-11.86Zm.1,26.08h-12.41c-1.59,0-1.83-1.05-1.83-1.94v-2.35c0-.63.47-1.36,1.62-1.36h12.62v5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m184.94,32.62h-21.66c-7.78,0-9.35,5.34-9.35,8.49v17.6c0,1.57,0,8.38,8.38,8.38h22.63v-8.43s-15.5.05-19.06.05c-2.75,0-3.56-1.18-3.56-3.61v-10.63c0-2.72,1.36-3.35,3.88-3.35h18.75v-8.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m136.81,32.62h-18.49c-8.38,0-8.38,7.54-8.38,8.48v25.98h8.38v-22.63c0-2.72,1.94-3.35,2.94-3.35h15.55v-8.48Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 140.74,
    y: 32.62,
    width: 8.38,
    height: 34.46
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m106.38,53.05v-11.94c0-2.72,0-8.49-8.38-8.49h-14.25c-6.23,0-8.38,4.24-8.38,8.49v17.6c0,3.14,0,8.38,8.38,8.38h18.43v-8.38h-14.24c-3.46,0-4.19-.86-4.19-3.46v-2.2h22.63Zm-22.63-10.58c0-1.36,1.13-1.36,1.91-1.36h10.53c1.26,0,1.81.6,1.81,1.36v1.98h-14.25v-1.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m35.15,32.62h11.31c6.68,0,6.99,3.85,6.99,3.85,0,0,0-3.85,7.15-3.85h2.83c7.65,0,8.38,6.23,8.38,11.84v22.63h-8.38v-22.63c0-2.72-1.65-3.35-2.75-3.35s-2.25.01-2.91.01v25.97h-8.59v-22.63c0-2.72-1.55-3.35-2.72-3.35h-2.93v25.98h-8.38v-34.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "255.37 73.02 263.75 73.02 263.75 84.85 278 84.85 278 73.02 286.38 73.02 286.38 107.48 278 107.48 278 93.45 263.75 93.45 263.75 107.48 255.37 107.48 255.37 73.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m233.77,81.41h-11.37v-8.38h31.06v8.59h-11.21v25.87h-8.49c0-2.91,0-26.08,0-26.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m189.38,73.02h8.38v22.71c0,2.36.89,3.38,2.93,3.38h11.31v-26.08h8.38v34.46h-21.77c-7.31,0-9.23-5.39-9.23-9.05v-25.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m177.41,73.02h-14.23c-1.36,0-8.38,0-8.38,8.38v16.68c0,6.72,3.98,9.4,9.26,9.4h13.25c5.81,0,8.48-3.22,8.48-10.81v-15.27c0-1.28,0-8.38-8.38-8.38Zm0,21.42c0,3.69-1.69,4.68-5.15,4.68h-4.46c-3.68,0-4.61-1.8-4.61-4.55v-8.27c0-3.35,1.57-4.9,5.06-4.9h4.1c3.88,0,5.06,1.7,5.06,5.16v7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m120.86,73.02h8.38v11.31c0,2.1.93,2.72,2.93,2.72h11.31v-14.04h8.38v26.08c0,8.38-6.26,8.38-8.38,8.38h-18.38v-8.36h15.56c2.26,0,2.83-1.07,2.83-2.85v-.63h-14.25c-6.98,0-8.38-3.82-8.38-8.59v-14.04Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login-logo.d6a8f42d34c0ff5efadbd81b02b9abd4.svg";
export { ForwardRef as ReactComponent };